<template>
  <a class="skip-link" href="#main">Skip to content</a>
  <header class="site-header">
    <RouterLink class="brand" to="/" aria-label="Consortium Chip Database home">
      <span class="brand-mark" aria-hidden="true">CDB</span>
      <span><strong>Consortium</strong><small>Chip Database</small></span>
    </RouterLink>
    <nav aria-label="Primary navigation">
      <RouterLink to="/">Catalog</RouterLink>
      <a href="https://db-api.csti.dev/api/v1/channels/stable">API</a>
      <a href="https://github.com/consortium-rs" rel="noreferrer">Project</a>
    </nav>
  </header>
  <main id="main"><RouterView /></main>
  <footer><span>Hardware truth, pinned to a release.</span><span>Schema 1.0 · API v1</span></footer>
</template>
